import { render, staticRenderFns } from "./field-form-basic.vue?vue&type=template&id=4e0f2430&"
import script from "./field-form-basic.vue?vue&type=script&lang=js&"
export * from "./field-form-basic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports